/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  filterRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '1rem',
  },
  textField: {
    maxWidth: 230,
  },
  button: {
    marginLeft: '2rem',
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
}));

const FilterPanel = ({ id, device, button, onChange, handleExport }) => {
  const classes = useStyles();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [patientValue, setPatientValue] = useState('');
  const [deviceValue, setDeviceValue] = useState('');

  useEffect(() => {
    if (id === null || id === undefined) {
      setPatientValue('');
    }
  }, [id]);

  const handleStartChange = (event) => {
    setStartDate(event.target.value);
    onChange({ start: event.target.value, end: endDate, patient: patientValue, device: deviceValue });
  };

  const handleEndChange = (event) => {
    setEndDate(event.target.value);
    onChange({ start: startDate, end: event.target.value, patient: patientValue, device: deviceValue });
  };

  const handlePatientChange = (value) => {
    setPatientValue(value);
  };

  const handleDeviceChange = (value) => {
    setDeviceValue(value);
  };

  const handleKeydown = (key) => {
    if (key === 'Enter') {
      onChange({ start: startDate, end: endDate, patient: patientValue, device: deviceValue });
    }
  };

  return (
    <div className={classes.filterRow}>
      <p>
        <b>Filters:</b>
      </p>
      {id === null && (
        <TextField
          label="Patient"
          type="text"
          variant="outlined"
          size="small"
          className={classes.textField}
          value={patientValue}
          onChange={(e) => handlePatientChange(e.target.value)}
          onKeyDown={(e) => handleKeydown(e.key)}
          onBlur={() => onChange({ start: startDate, end: endDate, patient: patientValue, device: deviceValue })}
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
      {device === null && (
      <TextField
        label="Monitor"
        type="text"
        variant="outlined"
        size="small"
        className={classes.textField}
        value={deviceValue}
        onChange={(e) => handleDeviceChange(e.target.value)}
        onKeyDown={(e) => handleKeydown(e.key)}
        onBlur={() => onChange({ start: startDate, end: endDate, patient: patientValue, device: deviceValue })}
        InputLabelProps={{
          shrink: true,
        }}
      />
      )}
      <TextField
        id="date1"
        label="Start"
        type="date"
        className={classes.textField}
        variant="outlined"
        size="small"
        value={startDate}
        onChange={handleStartChange}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <TextField
        id="date2"
        label="End"
        type="date"
        variant="outlined"
        size="small"
        value={endDate}
        onChange={handleEndChange}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <div className="filters">
        {button && (
        <Button className={classes.button} size="small" variant="contained" onClick={handleExport}>
          Export
        </Button>
        )}
      </div>
    </div>
  );
};

FilterPanel.propTypes = {
  id: PropTypes.number,
  device: PropTypes.string,
  button: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  handleExport: PropTypes.func,
};

FilterPanel.defaultProps = {
  id: null,
  device: null,
  button: true
};

export default FilterPanel;
